/**
 * Data for allocation donut
 */

module.exports = [
  // P1
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 36.59},
    {id: "obligations-souveraines", name: "Obligations",        value: 38.10},
    {id: "actions-us-canada",       name: "Actions",            value: 13.61},
    {id: "matieres-premieres",      name: "Matières premières", value: 7.77},
    {id: "alternatif",              name: "Alternatif",         value: 3.93}
  ],
  // P2
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 31.54},
    {id: "obligations-souveraines", name: "Obligations",        value: 37.42},
    {id: "actions-us-canada",       name: "Actions",            value: 19.40},
    {id: "matieres-premieres",      name: "Matières premières", value: 7.73},
    {id: "alternatif",              name: "Alternatif",         value: 3.91}
  ],
  // P3
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 26.52},
    {id: "obligations-souveraines", name: "Obligations",        value: 36.20},
    {id: "actions-us-canada",       name: "Actions",            value: 25.70},
    {id: "matieres-premieres",      name: "Matières premières", value: 7.69},
    {id: "alternatif",              name: "Alternatif",         value: 3.89}
  ],
  // P4
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 21.53},
    {id: "obligations-souveraines", name: "Obligations",        value: 34.05},
    {id: "actions-us-canada",       name: "Actions",            value: 32.93},
    {id: "matieres-premieres",      name: "Matières premières", value: 7.63},
    {id: "alternatif",              name: "Alternatif",         value: 3.86}
  ],
  // P5
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 16.67},
    {id: "obligations-souveraines", name: "Obligations",        value: 33.92},
    {id: "actions-us-canada",       name: "Actions",            value: 37.97},
    {id: "matieres-premieres",      name: "Matières premières", value: 7.60},
    {id: "alternatif",              name: "Alternatif",         value: 3.84}
  ],
  // P6
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 11.75},
    {id: "obligations-souveraines", name: "Obligations",        value: 26.86},
    {id: "actions-us-canada",       name: "Actions",            value: 49.98},
    {id: "matieres-premieres",      name: "Matières premières", value: 8.09},
    {id: "alternatif",              name: "Alternatif",         value: 3.32}
  ],
  // P7
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 6.99},
    {id: "obligations-souveraines", name: "Obligations",        value: 25.81},
    {id: "actions-us-canada",       name: "Actions",            value: 55.84},
    {id: "matieres-premieres",      name: "Matières premières", value: 8.05},
    {id: "alternatif",              name: "Alternatif",         value: 3.31}
  ],
  // P8
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 2.33},
    {id: "obligations-souveraines", name: "Obligations",        value: 22.96},
    {id: "actions-us-canada",       name: "Actions",            value: 63.40},
    {id: "matieres-premieres",      name: "Matières premières", value: 8.02},
    {id: "alternatif",              name: "Alternatif",         value: 3.29}
  ],
  // P9
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 0.00},
    {id: "obligations-souveraines", name: "Obligations",        value: 18.84},
    {id: "actions-us-canada",       name: "Actions",            value: 68.94},
    {id: "matieres-premieres",      name: "Matières premières", value: 8.99},
    {id: "alternatif",              name: "Alternatif",         value: 3.23}
  ],
  // P10
  [
    {id: "fonds-euro",              name: "Fonds Euro",         value: 0.00},
    {id: "obligations-souveraines", name: "Obligations",        value: 10.48},
    {id: "actions-us-canada",       name: "Actions",            value: 77.41},
    {id: "matieres-premieres",      name: "Matières premières", value: 8.91},
    {id: "alternatif",              name: "Alternatif",         value: 3.20}
  ]
];